import React, { useEffect, useState } from 'react';
import { GrNotes } from "react-icons/gr";
import { FiEdit2, FiTrash2, FiSave, FiX } from "react-icons/fi";
import './NotesSection.css'; // 🔗 Import external stylesheet
import ReferralDS from '../../DataServices/ReferralDs';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { insertLog } from '../Logs/InsertLog';

const NotesSection = ({ initialNotes = [], referralID, fetchReferralData }) => {
  const [notes, setNotes] = useState(initialNotes);
  const [newNote, setNewNote] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedNote, setEditedNote] = useState('');
  const { showAlert, hud, stopHudRotation, showToast } = useCustomContext();
  const notesAdd = new ReferralDS();
  const useremail = localStorage.getItem("email");
  const userName = useremail?.split('@')[0]
  useEffect(() => {
    setNotes(initialNotes);
  }, [initialNotes]);
  const insertNote = async ({ referralID, noteText, noteAddedBy }) => {
    try {
      hud && hud('Please Wait...');

      const requestData = {
        referralID,
        noteText,
        noteAddedBy,
      };

      const response = await notesAdd.RM_Referrals_Notes_Insert(requestData);
      const data = response.data;

      if (data.statusCode !== 200) {
        const message = data.body?.message || 'Log failed';
        showAlert(message, [
          {
            label: "Ok",
            onClick: () => { },
            color: "var(--buttonColor)"
          }
        ]);

        return false;
      }

      const isSuccess = data.statusCode === 200;

      const logDescription = `${userName} added a new note: "${newNote}"`;
      await insertLog(logDescription, referralID, useremail, hud, stopHudRotation, showAlert);

      if (!isSuccess) throw new Error("Failed status code");

      const message =
        typeof response.data.body === "string"
          ? JSON.parse(response.data.body).message
          : response.data.body?.message;

      if (typeof fetchReferralData === "function") {
        await fetchReferralData();
      }

      showToast({ message }); // 🔄 toast on success
      return true;

    } catch (error) {
      const message = error?.response?.data?.message || error.message || 'Logging error';
      showAlert(message, [
        {
          label: "Ok",
          onClick: () => { },
          color: "var(--buttonColor)"
        }
      ]);
      // 🔄 toast on error
      return false;
    } finally {
      stopHudRotation && stopHudRotation();
    }
  };


  const handleAddNote = async () => {

    if (newNote.trim() === '') {
      showAlert("Please enter a note before saving.", [
        { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" },
      ]);
      return;
    }

    const success = await insertNote({
      referralID: referralID, // Replace '1' with actual fallback if needed
      noteText: newNote,
      noteAddedBy: useremail, // Use actual logged-in user
    });

    if (success) {
      // setNotes([newNote, ...notes]);
      setNewNote('');
      setShowAdd(false);
    }
  };


  const handleDelete = (index) => {
    const updated = [...notes];
    updated.splice(index, 1);
    setNotes(updated);
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditedNote(notes[index]);
  };

  const handleSaveEdit = () => {
    const updated = [...notes];
    updated[editingIndex] = editedNote;
    setNotes(updated);
    setEditingIndex(null);
    setEditedNote('');
  };

  return (
    <div className="notes-container">
      <h3 className="notes-heading">
        <GrNotes className="notes-icon" /> Notes
      </h3>

      <div className="notes-list">
        {notes.length === 0 && <p className="no-notes">No notes yet.</p>}
        {notes.map((note, idx) => (
          <div key={idx} className="note-item">
            {editingIndex === idx ? (
              <div className="note-edit-section">
                <textarea
                  value={editedNote}
                  onChange={(e) => setEditedNote(e.target.value)}
                  className="note-textarea"
                />
                <div className="note-edit-buttons">
                  <button onClick={handleSaveEdit} className="note-btn save-btn">
                    <FiSave /> Save
                  </button>
                  <button onClick={() => {
                    setEditingIndex(null);
                    setEditedNote('');
                  }} className="note-btn cancel-btn">
                    <FiX /> Cancel
                  </button>
                </div>
              </div>
            ) : (
              <>
                <p className="note-text">{note}</p>
                {/* <div className="note-actions">
                  <button onClick={() => handleEdit(idx)} className="action-btn edit-btn"><FiEdit2 /></button>|
                  <button onClick={() => handleDelete(idx)} className="action-btn delete-btn"><FiTrash2 /></button>
                </div> */}
              </>
            )}
          </div>
        ))}
      </div>

      {showAdd ? (
        <div className="add-note-form">
          <textarea
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            className="note-textarea"
            placeholder="Type your note here..."
          />
          <div className="note-edit-buttons">
            <button onClick={handleAddNote} className="btn save-btn">Save Note</button>
            <button onClick={() => {
              setShowAdd(false);
              setNewNote('');
            }} className="btn cancel-btn">Cancel</button>
          </div>
        </div>
      ) : (
        <button onClick={() => setShowAdd(true)} className="add-note-btn">
          + Add Note
        </button>
      )}
    </div>
  );
};

export default NotesSection;
